import { FREE_ADJECTIVE_WORD } from '@glass/common/modules/content/staticVariations/adjectiveWords/adjectiveWordVariations';

const makePaidBuilderBasePath = (str: string | null | undefined) =>
  str?.replace(new RegExp(`^${FREE_ADJECTIVE_WORD}-`), '') || '';

export default makePaidBuilderBasePath;
